export class TenantDeparmentDto {
  id?: string;
  name: string = '';
  createdAt: Date = new Date();
}
